import React from 'react';
import { Card, CardBody, CardTitle } from 'reactstrap';

import IntlMessages from '../../../../../../helpers/IntlMessages';
import ReactTable from 'react-table';
import DataTablePagination from '../../../../../../components/DatatablePagination';

const ChatbotCountByType = ({ labels, data }) => {
    return (
        <Card>
            <div style={{ padding: '15px' }}>
                <div className="float-left float-none-xs">
                    <div className="d-inline-block">
                        <h5 className="d-inline">
                            AI Chatbot Clients by Type
                        </h5>
                        <span className="text-muted text-small d-block">
                            List of live clients using AI Chatbot
                        </span>
                    </div>
                </div>
            </div>
            <CardBody>
                <ReactTable
                    data={data}
                    columns={labels}
                    defaultPageSize={5}
                    filterable={false}
                    showPageJump={true}
                    PaginationComponent={DataTablePagination}
                    showPageSizeOptions={true}
                    defaultSorted={[
                        {
                            id: 'liveChatbot',
                            desc: true,
                        },
                    ]}
                />
            </CardBody>
        </Card>
    );
};

export default ChatbotCountByType;
